{
  "language": "English US",
  "basics": {
    "loading": "Loading..."
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "leader-compass": "Leader Compass",
    "billing": "Billing",
    "checkout": "Checkout",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects",
    "start-test": "Start challenge",
    "dashboard": "Leader compass"
  },
  "login": {
    "welcomeMessage": "Welcome, and may these tests show the true courage that lies within your heart.",
    "loginButton": "Log in",
    "registerButton": "Register"
  },
  "loginBtn": {
    "login": "Login",
    "logout": "Logout",
    "register": "Register"
  },
  "register": {
    "loading": "Finalizing Your Setup...",
    "please_wait": "Please wait a moment.",
    "profile": "Complete Your Profile",
    "insp_txt": "Let's get you started on your journey.:",
    "step_1": "Step 1: Eligibility",
    "step": "Step",
    "18_years": "I confirm that I am over 18 years old.",
    "newsletter": "I would like to receive the newsletter",
    "step_2": "Step 2: Skills of Interest",
    "loading_skills": "Loading skills...",
    "skills_failed": "Failed to load skills. Please try again later.",
    "skills_warning": "You must select between 4 and 8 skills.",
    "step_3": "Step 3: Choose Your Hero",
    "heroes_loading": "Loading heroes...",
    "heroes_failed": "Failed to load heroes. Please try again later.",
    "heroes_warning": "Please select a hero to continue.",
    "btn_back": "Back",
    "btn_next": "Next",
    "btn_complete": "Complete Registration",
    "completeReg": "Complete Registration",
    "from": "of"
  },
  "404": {
    "header": "Page not found",
    "text": "The page you are looking for might have been removed had its name changed or is temporarily unavailable.",
    "btn": "Go to homepage"
  },
  "userCheck": {
    "loading": "Verifying registration...",
    "errorBold": "Error!",
    "message": "Could not verify registration."
  },
  "skills": {
    "adaptabilityAndStrategicFlexibility": "Adaptability and Strategic Flexibility",
    "decisivenessAndCalculatedRiskTaking": "Decisiveness and Calculated Risk-Taking",
    "inspirationalCommunication": "Inspirational Communication",
    "diplomacyAndAllianceBuilding": "Diplomacy and Alliance Building",
    "decisivenessAndCommandPresence": "Decisiveness and Command Presence",
    "projectionOfPowerAndConfidence": "Projection of Power and Confidence",
    "establishmentOfClearStructuresAndConsequences": "Establishment of Clear Structures and Consequences",
    "expertiseAndCompetence": "Expertise and Competence",
    "leadingByExampleAndPersonalCourage": "Leading by Example and Personal Courage",
    "integrityAndMoralConsistency": "Integrity and Moral Consistency",
    "benevolenceAndCareForFollowers": "Benevolence and Care for Followers",
    "humilityAndAcknowledgingOthers": "Humility and Acknowledging Others",
    "diplomacyAndStrategicNegotiation": "Diplomacy and Strategic Negotiation",
    "capitalAllocationLogistics": "Capital Allocation (Logistics)",
    "empathyAndPerspectiveTaking": "Empathy and Perspective-Taking",
    "demonstratingValueAndMutualBenefit": "Demonstrating Value and Mutual Benefit",
    "reliabilityAndTrustworthiness": "Reliability and Trustworthiness",
    "inspirationalCommunicationAndMaintainingMorale": "Inspirational Communication and Maintaining Morale",
    "strategicPlanningAndForeknowledge": "Strategic Planning and Foreknowledge",
    "adaptabilityAndInnovation": "Adaptability and Innovation",
    "calculatedRiskTaking": "Calculated Risk-Taking",
    "strategicPatience&Decisiveness": "Strategic Patience & Decisiveness",
    "superiorRiskAssessment": "Superior Risk Assessment",
    "emotionalDetachment&Discipline": "Emotional Detachment & Discipline",
    "intelligenceGatheringScouting": "Intelligence Gathering (Scouting)",
    "resilience&Endurance": "Resilience & Endurance",
    "commandOfFear": "Command of Fear"
  },
  "preferences": {
    "preferences": "Preferences",
    "user": "USER",
    "memberSince": "Member since",
    "loading": "Loading preferences...",
    "failed": "Failed to load preferences.",
    "subscribed": "Subscribed",
    "notSubs": "Not Subscribed",
    "newsletter": "Newsletter",
    "age": "Legal age",
    "agree": "Agreed",
    "notAgree": "Not Agreed",
    "btnEdit": "Edit",
    "hero": "Hero",
    "loadingHero": "Loading hero...",
    "noHero": "No hero selected",
    "changeHero": "Change Hero",
    "skills": "Skills",
    "loadingSkills": "Loading skills...",
    "noSkills": "No skills selected",
    "btnEditSkills": "Edit Skills",
    "language": "Language",
    "mdlPrefTitle": "Update your newsletter and terms agreement settings.",
    "mdlSubscribe": "I would like to receive the newsletter.",
    "mdlAge": "I agree to the terms and conditions.",
    "btnCancel": "Cancel",
    "btnSave": "Save Changes",
    "mdlHeroFailed": "Failed to load heroes.",
    "mdlSkillsFailed": "Failed to load data.",
    "mdlSkillsSelectText": "Select all skills that apply:",
    "mdlHeroTitle": "Change Your Hero",
    "mdlSkillsTitle": "Edit Your Skills"
  },
  "test": {
    "timeLeftDesc": "Your next challenge will be unlocked in:",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "title": "Standard Challenge",
    "failedLoading": "Failed to load test data.",
    "testLoading": "Our AI is analysing thousands of historical data points to craft a uniquely intelligent challenge for you. This deep cognitive synthesis requires up to 5 minutes. Excellence is worth the wait.",
    "startTest": "Start Standard Challenge",
    "unlock": "Unlock Advanced Challenges",
    "subscribe": "Subscribe to generate your own custom Challenge.",
    "viewPlans": "View Plans",
    "generatingChallenge": "Generating your custom challenge...",
    "pleaseWait": "This can take a moment. Please wait.",
    "craft": "Craft Your Ultimate Challenge",
    "couldNotLoad": "Could not load filter options.",
    "mainSkill": "Focus Skill (Max 1)",
    "lblCountry": "Country / Region",
    "lblCentury": "Century / Era",
    "lblAdditionalSkills": "Additional Skills",
    "btnLoadMore": "Load more",
    "lblMen": "Men",
    "lblWoman": "Women",
    "difficulty": "Select Challenge Difficulty",
    "advancedChallenge": "Take Advanced Challenge",
    "generateNew": "Generate New",
    "errSelectWarrior": "Please select at least one leader to proceed.",
    "startChallenge": "Generate Advanced Challenge",
    "plcHldrCountries": "Search for a country...",
    "plcHldrCenturies": "Select one or more eras",
    "plcHldrSkills": "Choose your skills",
    "previousTests1": "You have completed",
    "previousTests2": "challenges so far.",
    "challenge": "Loading your challenge...",
    "challengeLoadError": "There was an error loading the test. Please ",
    "challengeLoadErrorBtn": "try again",
    "challengeNoData": "No test data available. Please start a new test.",
    "question": "Question",
    "challengeCompleteBtn": "Complete Challenge",
    "challengeNextQuestionBtn": "Next Question",
    "analyzing": "Analyzing Your Path...",
    "resultsSubtitle": "Great leaders are forged in moments of reflection. We're preparing your personalized insights.",
    "resultsError": "An Unexpected Hurdle",
    "resultsErrorBtn": "Retry Submission",
    "journeyTitle": "Your Journey Begins Now",
    "journeySubtitle": "You've completed the challenge and unlocked your path to leadership.",
    "journeyPerformance": "Your Performance",
    "resultsCorrectAnswers": "Correct Answers",
    "resultsInspiration": "Inspirational Parallels",
    "resultsInspirationSubtitle": "Your approach mirrors the strengths of legendary leaders:",
    "resultsTitle2": "Your Path to Mastery",
    "resultsSubtitle2": "Every great leader has skills to hone. Here is your personalized curriculum.",
    "addSkillsBtn": "Add skill to your profile",
    "newChallengeBtn": "Take a New Challenge",
    "completeRegistration": "Complete Registration"
  },
  "filter": {
    "btnClose": "Close",
    "politics": "Politics",
    "arts": "Arts",
    "business": "Business",
    "finance": "Finance",
    "science": "Science",
    "public": "Public relationship",
    "publicCommunication": "Public relationship",
    "law": "Law",
    "engineering": "Engineering",
    "military": "Military",
    "marketing": "Marketing",
    "global": "Global",
    "europe": "Europe",
    "asia": "Asia",
    "africa": "Africa",
    "northAmerica": "North America",
    "oceania": "Ocenia",
    "southAmerica": "South America",
    "afghanistan": "Afghanistan",
    "albania": "Albania",
    "algeria": "Algeria",
    "andorra": "Andorra",
    "angola": "Angola",
    "antiguaAndBarbuda": "Antigua and Barbuda",
    "argentina": "Argentina",
    "armenia": "Armenia",
    "australia": "Australia",
    "austria": "Austria",
    "azerbaijan": "Azerbaijan",
    "bahamas": "Bahamas",
    "bahrain": "Bahrain",
    "bangladesh": "Bangladesh",
    "barbados": "Barbados",
    "belarus": "Belarus",
    "belgium": "Belgium",
    "belize": "Belize",
    "benin": "Benin",
    "bhutan": "Bhutan",
    "bolivia": "Bolivia",
    "bosniaAndHerzegovina": "Bosnia and Herzegovina",
    "botswana": "Botswana",
    "brazil": "Brazil",
    "brunei": "Brunei",
    "bulgaria": "Bulgaria",
    "burkinaFaso": "Burkina Faso",
    "burundi": "Burundi",
    "cambodia": "Cambodia",
    "cameroon": "Cameroon",
    "canada": "Canada",
    "centralAfricanRepublic": "Central African Republic",
    "chad": "Chad",
    "chile": "Chile",
    "china": "China",
    "colombia": "Colombia",
    "costaRica": "Costa Rica",
    "croatia": "Croatia",
    "cuba": "Cuba",
    "cyprus": "Cyprus",
    "czechRepublic": "Czech Republic",
    "denmark": "Denmark",
    "djibouti": "Djibouti",
    "dominicanRepublic": "Dominican Republic",
    "ecuador": "Ecuador",
    "egypt": "Egypt",
    "elSalvador": "El Salvador",
    "equatorialGuinea": "Equatorial Guinea",
    "estonia": "Estonia",
    "ethiopia": "Ethiopia",
    "fiji": "Fiji",
    "finland": "Finland",
    "france": "France",
    "georgia": "Georgia",
    "germany": "Germany",
    "ghana": "Ghana",
    "greece": "Greece",
    "guatemala": "Guatemala",
    "haiti": "Haiti",
    "honduras": "Honduras",
    "hungary": "Hungary",
    "iceland": "Iceland",
    "india": "India",
    "indonesia": "Indonesia",
    "iran": "Iran",
    "iraq": "Iraq",
    "ireland": "Ireland",
    "israel": "Israel",
    "italy": "Italy",
    "japan": "Japan",
    "kazakhstan": "Kazakhstan",
    "kenya": "Kenya",
    "kuwait": "Kuwait",
    "laos": "Laos",
    "latvia": "Latvia",
    "lebanon": "Lebanon",
    "lithuania": "Lithuania",
    "luxembourg": "Luxembourg",
    "malaysia": "Malaysia",
    "mexico": "Mexico",
    "monaco": "Monaco",
    "mongolia": "Mongolia",
    "morocco": "Morocco",
    "nepal": "Nepal",
    "netherlands": "Netherlands",
    "newZealand": "New Zealand",
    "nigeria": "Nigeria",
    "norway": "Norway",
    "pakistan": "Pakistan",
    "panama": "Panama",
    "peru": "Peru",
    "philippines": "Philippines",
    "poland": "Poland",
    "portugal": "Portugal",
    "qatar": "Qatar",
    "romania": "Romania",
    "russia": "Russia",
    "saudiArabia": "Saudi Arabia",
    "singapore": "Singapore",
    "slovakia": "Slovakia",
    "slovenia": "Slovenia",
    "southAfrica": "South Africa",
    "southKorea": "South Korea",
    "spain": "Spain",
    "sriLanka": "Sri Lanka",
    "sweden": "Sweden",
    "switzerland": "Switzerland",
    "taiwan": "Taiwan",
    "thailand": "Thailand",
    "turkey": "Turkey",
    "uganda": "Uganda",
    "ukraine": "Ukraine",
    "unitedArabEmirates": "United Arab Emirates",
    "unitedKingdom": "United Kingdom",
    "unitedStates": "United States",
    "uruguay": "Uruguay",
    "uzbekistan": "Uzbekistan",
    "venezuela": "Venezuela",
    "vietnam": "Vietnam",
    "yemen": "Yemen",
    "any": "Any",
    "classicalAntiquity": "Classical Antiquity",
    "theHighMiddleAgesAndTheCrusades": "The High Middle Ages and The Crusades",
    "theRenaissance": "The Renaissance",
    "theAgeOfDiscoveryAndTheReformation": "The Age of Discovery and The Reformation",
    "theEnlightenment": "The Enlightenment",
    "theAgeOfRevolutions": "The Age of Revolutions",
    "19thCentury": "19th Century",
    "20thCentury": "20th Century",
    "twentyFirstCentury": "21st Century"
  },
  "billing": {
    "title": "Billing Information",
    "tierTitle": "Membership Tier",
    "planWTitle": "weekly",
    "planWName": "Weekly Membership",
    "planWPrice": "7.99 EUR / week",
    "planFTitle": "free",
    "planFName": "Free Tier",
    "planFPrice": "Free",
    "paymentTitle": "Payment Info",
    "paymentPlan": "Payment plan",
    "paymentPrice": "7.99 EUR / weekly",
    "paymentManage": "Manage Billing & Invoices"
  },
  "dashboard": {
    "title": "Dashboard",
    "subline": "Track your progress, master new skills, and discover the hero within.",
    "error": "Failed to load Dashboard",
    "errorSubline": "Could not fetch your statistics. Please try refreshing the page.",
    "skillName": "Your Signature Skill",
    "skillSubline": "Your strongest talent shines through in...",
    "skillMastery": "Mastery",
    "warriorTitle": "The Warrior's Compass",
    "hero": "Hero Affinity",
    "armory": "The Armory: Skill Breakdown",
    "foes": "Toughest Foes",
    "foesSubtitle": "Keep up the great work.",
    "since": "since last month"
  },
  "payment": {
    "title": "Level up your game. Unlock advanced challenges and start your mastery journey today",
    "subtitle": "Unlock the Inner Circle. Join our weekly membership for an all-access pass to the advanced challenges that set the pros apart.",
    "weekly": "Weekly Membership",
    "price": "7.99 EUR / week",
    "explanation": "Your world, your leaders, your challenges. Select the era, the region, and the industry—from marketing to military—and align every task with your personal skill set. Join now for 7.99 EUR per week and gain total access to a world of expertise. Flexibility is built-in: cancel your membership at any time via your billing page.",
    "paymentInfo": "Payment Information",
    "loading": "Initializing secure payment form...",
    "success": "Payment Successful!",
    "successExpl": "Welcome to the club! You’ve officially unlocked our advanced challenges. The best part? You're in total control. Set your preferences, play by your own rules, and dive right in!",
    "btnDashboard": "Go to Dashboard",
    "manage": "Manage Your Subscription",
    "manageExpl": "You have an active weekly membership. You can manage your subscription, update your payment method, and view your invoice history from the customer portal.",
    "myPlan": "Active Plan: Weekly Membership",
    "planExpl": "Your next billing date will be handled by the subscription renewal.",
    "upgradePlan": "Manage Billing & Invoices"
  },
  "superhero": {
    "the_captain": "The Captain",
    "the_admiral": "I am The Admiral. When the waves of chaos rise, I am the steady hand on the helm. My power? Unbreakable Resolve. I see the path through any storm when others see only the dark. Join my crew. I will forge you into a leader, someone who can command, inspire, and protect. Your greatest voyage is about to begin. Take your post.",
    "the_lawyer": "The Lawyer",
    "the_advocate": "They call me The Advocate. I speak for those who have no voice. My superpower is Truth. In a world of lies, my words are the key that unlocks any door and breaks any chain. Do you believe in justice? Do you want the power to find the right answer and make your voice heard? Join me. Let's fight for what's right.",
    "the_business_consultant": "The Business Consultant",
    "the_catalyst": "I'm The Catalyst. I don't just see the future; I build it. My power is Transformation. I can look at any broken system, any failed idea, and see a billion-dollar success. You have potential. You have a drive. But you need the plan. Choose me, and I'll give you the blueprints to build your empire.",
    "the_couch": "The Coach",
    "couch_victory": "I'm Coach Victory. My arena is life, and I hate losing. My power isn't magic; it's Potential. I can see the champion inside you, even when you can't. It will be hard. You will be tested. But I will never give up on you. Are you ready to work? Are you ready to win? Get off the bench. It's game time.",
    "the_school_bully": "The School Bully",
    "rex": "Call me Rex. I'm not your hero. I'm the one who knows the real rules. My power? Gravity. I know how to make people listen. I know how to take what I want. This world isn't nice. You can be the one who gets pushed, or you can be the one who does the pushing. You want to learn how to stand up? How to never be scared again? Fine. Follow me. But don't slow me down.",
    "the_professor": "The Professor",
    "the_chronicler": "I am The Chronicler. I possess the world's most powerful weapon: Knowledge. I have read every book, seen every timeline, and understood every mistake humanity has ever made. Ignorance is the true enemy. Choose me, and I will grant you the power of knowing. You will learn to see the patterns that no one else can. Are you ready to truly understand?",
    "the_data_analyst": "The Data Analyst",
    "the_oracle": "I am The Oracle. My mind is a sea of data, and I can see the future. My power is Clarity. In a world of noise and confusion, I see the one true signal. I can predict the next move, the next market crash, the next victory. You want to stop guessing and start knowing? Connect with me. I'll show you the code behind reality.",
    "the_spy": "The Spy",
    "whisper": "My name is a secret. You can call me Whisper. I move in the shadows, and my power is Invisibility. I see all, hear all, and am never seen. I am the one who solves the crisis before anyone knows it began. You don't need to be the loudest in the room to be the most powerful. Choose me, and I will teach you the art of the unseen.",
    "the_marketing_specialist": "The Marketing Specialist",
    "the_hype": "Hey! I'm The Hype. I'm the one who makes the world fall in love. My superpower? Influence. I can turn a rock into a diamond. I can make a single idea change the world. You have a story, an idea, a you that the world needs to see. I can teach you how to tell that story. Choose me, and we'll make them listen.",
    "the_chief_strategist": "The Chief Strategist",
    "the_architect": "I am The Architect. While others fight on the battlefield, I am winning the war from the command tent. My power is Foresight. I see 100 moves ahead. Every choice you make is a piece on the board. You can learn to play the game, or you can learn to win it. Choose me, and you will never be surprised again.",
    "the_producer": "The Producer",
    "max_impact": "Call me Max-Impact. I'm the one who makes the impossible, possible. My power? Creation. You have a script with no budget? I'll make the blockbuster. You have a dream with no resources? I'll make it real. Life is about doing. You want to sit around and talk, or do you want to make magic? Let's go. We're losing daylight!",
    "the_venture_capitalist": "The Venture Capitalist",
    "the_visionary": "I am The Visionary. My power is Investment. I don't see what is; I see what could be. I look at a tiny seed and see a forest. My one 'yes' can change the world. But I don't bet on ideas; I bet on people. I see that potential in you. Choose me, and I will show you how to find value, take the right risks, and build a future.",
    "the_political_strategist": "The Political Strategist",
    "the_hand_shake": "I'm The Handshake. I'm the voice in the leader's ear, the one who builds the alliance, the one who wins the election before the first vote is cast. My power is Persuasion. I can build a bridge or start a revolution, all with a few well-placed words. You want to learn how to lead people? How to build a movement? I'm the one you need.",
    "the_engineering_fellow": "The Engineering Fellow",
    "the_engineer": "I am The Engineer. I'm not a wizard. I'm just smarter than the problem. My superpower is Logic. While others are panicking, I'm building the solution. The world is full of broken systems, and I'm the one who fixes them. You don't need magic when you have math. You have a logical mind. Let me show you how to use it to build, to fix, and to create.",
    "the_priest": "The Priest",
    "the_anchor": "I am The Anchor. In a world of noise, I am the silence. In a world of chaos, I am the calm. My power is Empathy. I can heal the wounds no one else sees. I listen to the heart, not just the words. True strength isn't about how loud you shout, but how deeply you understand. Choose me, and I will show you how to be the calm in the storm, for yourself and for others."
  },
  "unsorted": {
    "home": "Home",
    "difficulty": "Difficulty",
    "levels": {
      "standard": "Standart",
      "difficult": "Difficult",
      "killer": "Very hard"
    },
    "untested": "Untested",
    "payment": {
      "processing": "Processing...",
      "start_membership": "Start membership - 7,99 EUR"
    }
  },
  "landingPage": {
    "nav": {
      "brand": "MindForge AI",
      "login_start": "Start Your Rewire",
      "loading": "Calibrating Neural Baseline..."
    },
    "hero": {
      "badge": "AI-POWERED COGNITIVE ARCHITECTURE",
      "cta": "Start for free"
    },
    "fellows": {
      "title": "Which Protocol Is Running Your Life?",
      "subtitle": "Discover the hidden archetype controlling your decisions.",
      "filter_all": "All",
      "more_archetypes": "+ 6 More Archetypes",
      "more_archetypes_list": "The Devout Mystic, The Righteous Crusader, The Traditionalist...",
      "explore_all": "Explore All 12"
    },
    "personas": {
      "captain": {
        "title": "The Captain",
        "desc": "For leaders who crave stability, responsibility, and clear direction. You are the protector."
      },
      "vc": {
        "title": "The VC",
        "desc": "Risk-taker. Dreamer. Value Creator. You identify the 100x opportunity."
      },
      "survivor": {
        "title": "The Survivor",
        "desc": "Street-smart. Assertive. Raw confidence. Power through adversity."
      },
      "analyst": {
        "title": "The Data Analyst",
        "desc": "Facts over feelings. You out-think challenges with logic, data, and precision."
      },
      "spy": {
        "title": "The Spy",
        "desc": "Subtlety & Patience. Win by being smarter, not stronger."
      },
      "priest": {
        "title": "The Priest",
        "desc": "Integrity. Empathy. Lead with compassion and moral consistency."
      },
      "producer": {
        "title": "The Producer",
        "desc": "Chaotic Energy. Grit. Resourcefulness. You make big ideas happen."
      },
      "politician": {
        "title": "Political Strategist",
        "desc": "Charisma. Influence. Alliance-building. Power comes from people."
      }
    },
    "engine": {
      "badge": "Behavioral Modeling Engine",
      "title": "We decode your hidden operating system.",
      "description": "Willpower is a myth. Our AI analyzes your unique archetype's neurochemical drivers and replaces your deepest vulnerabilities with automated, high-leverage habits.",
      "example_old_label": "Historical Event",
      "example_old_text": "Napoleon navigates a supply shortage before Austerlitz.",
      "example_new_label": "Generated Scenario",
      "example_new_text": "Your startup has 2 months of runway left. Do you cut costs or pivot aggressive marketing?"
    },
    "dashboard": {
      "analysis": "Growth Analysis",
      "feedback_label": "Analysis",
      "feedback_text": "Your decision mirrored Elon Musk's 2008 risk strategy. You prioritized long-term alliance over short-term capital protection."
    },
    "skills": {
      "section_title": "Master The Traits of the Elite 1%",
      "commandOfFear": "Fear Alchemization",
      "strategicPatienceDecisiveness": "Strategic Patience",
      "calculatedRiskTaking": "Asymmetric Risk-Taking",
      "emotionalDetachmentDiscipline": "Emotional Detachment",
      "diplomacyAndAllianceBuilding": "Magnetic Charisma",
      "intelligenceGatheringScouting": "Social Dynamics Reading",
      "resilienceEndurance": "Stress Immunity",
      "projectionOfPowerAndConfidence": "Unshakable Frame Control",
      "capitalAllocationLogistics": "Focus Allocation",
      "inspirationalCommunication": "Persuasive Storytelling",
      "decisivenessAndCommandPresence": "Absolute Decisiveness"
    },
    "footer": {
      "title_line1": "Don't just desire success.",
      "title_line2": "Engineer it.",
      "cta": "Start Your Rewire Now",
      "subtext": "Free to start. No credit card required."
    }
  },
  "untranslated": {
    "fellowUpdated": "Fellow updated",
    "fellowUpdateError": "Error while updating fellow",
    "skillsUpdated": "Sucesfuly updated skills",
    "skillsUpdateError": "Error hile updating skills",
    "skillsMaxExceeded": "Maximum number of skills reached",
    "testReady": "Your chalange is ready. You can start now",
    "becomeSubscriber": "Subsribe",
    "advancedChallengeReady": "Advanced chalange ready. You can start now",
    "notASubscriber": "Please subsribe to enter this area",
    "testGenerationError": "There was an error while generating your chalange",
    "generateNew": "Start test generation",
    "testGenerationFailed": "Unfortunaly your chalange were not created",
    "registrationFailed": "Unable to complete registration",
    "skillsSaved": "Your skills are set",
    "skillsSaveError": "Unable to save new skills",
    "testPreparing": "Your chalange is beeing prepared",
    "uncompletedRegistration": "Unable to complete user registration",
    "maximum skills": "Number of maximum skills reached"
  },
  "additional": {
    "try3Days": "Try 3 days for free",
    "try3DaysLong": "Unlock 72 hours of unrestricted access to our advanced challenges. Subscribe at zero cost and start pushing your limits today!",
    "tryForFreeBtn": "Try for free",
    "subscribe": "Subscribe now",
    "advancedChallengeTitle": "Unlock the Advanced Challenge",
    "advancedChallengeText": "Don't just read about history's greatest leaders—live their success. Mix and match the world's most powerful life stories with the specific skills you need to win your day and conquer your goals.",
    "landingPageTitle1": "From Unnoticed to Unstoppable:",
    "landingPageTitle2": "Rewire Your Deepest Archetype",
    "landingPageSubtitle": "Stop chasing goals with pure willpower. Our AI-powered behavioral engine analyzes your psychological prototype, attacks your core vulnerabilities, and installs the ultimate internal operating system for life-changing results."
  }
}
